import React from 'react'
import CrudDinamicoListPageContainer from './CrudDinamicoListPageContainer'

export class CrudDinamicoListPage extends React.Component {
  render() {
    return <CrudDinamicoListPageContainer {...this.props} />
  }
}
